<template>
  <div>
    <Sections></Sections>
  </div>
</template>

<script>
// import News from './News'
import Sections from './Sections'
export default {
  name: 'LeftBox',
  components: {
    // News,
    Sections
  }
}
</script>

<style>

</style>
